import React from "react";

/**
 * Audio capture line-art icon — Lucide "mic" stroke glyph.
 * Used on Capture list thumbs only; same purple stroke as other thumb glyphs.
 */
const MicLineArt = ({
  color = "#8F38EF",
  width = 24,
  height = 24,
  strokeWidth = 2,
  style,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={{ width, height, flexShrink: 0, ...style }}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-mic"
    aria-hidden="true"
    {...rest}
  >
    <path d="M12 19v3" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <rect x="9" y="2" width="6" height="13" rx="3" />
  </svg>
);

export default MicLineArt;
